var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-color-picker',{model:{value:(_vm.theme),callback:function ($$v) {_vm.theme=$$v},expression:"theme"}})
}
var staticRenderFns = []

export { render, staticRenderFns }